import { throttle } from 'lodash';
import { useEffect, useState } from 'react';
import { useRef } from 'react';

export const useIsInViewport = (
  options: {
    throttleMilliseconds?: number;
  } = {}
) => {
  const { throttleMilliseconds = 1000 } = options;
  const elementRef = useRef<HTMLElement>(null);
  const [isInViewport, setIsInViewport] = useState<boolean>(false);
  const [isUnderViewport, setIsUnderViewport] = useState<boolean>(false);
  const [isAboveViewport, setIsAboveViewport] = useState<boolean>(false);

  const processIsInViewport = () => {
    if (!elementRef.current) return;

    const { top, bottom } = elementRef.current.getBoundingClientRect();

    const { clientHeight } = document.documentElement;
    const { innerHeight } = window;

    setIsInViewport(bottom >= 0 && top <= (innerHeight || clientHeight));

    setIsUnderViewport(top >= (innerHeight || clientHeight));
    setIsAboveViewport(bottom <= 0);
  };

  useEffect(() => {
    const processIsInViewportThrottled = throttle(
      processIsInViewport,
      throttleMilliseconds
    );

    addEventListener('scroll', processIsInViewportThrottled);

    return () => {
      removeEventListener('scroll', processIsInViewportThrottled);
      processIsInViewportThrottled.cancel();
    };
  }, [elementRef, throttleMilliseconds]);

  return { elementRef, isInViewport, isUnderViewport, isAboveViewport };
};
